import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  unlockPaymentRunAPI,
  type GetPaymentRunReviewParams,
} from '~entities/payment/api/reporting-payment-run-review';
import { QUERY_KEYS } from '~shared/api/query-keys';

export type { UnlockPaymentRunResponse } from '~entities/payment/api/reporting-payment-run-review';

export interface UseUnlockPaymentRunOptions {
  /** When provided, invalidates this report query on success */
  reportParams?: GetPaymentRunReviewParams;
}

export const useUnlockPaymentRunMutation = (
  options?: UseUnlockPaymentRunOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => unlockPaymentRunAPI(),
    onSuccess: () => {
      if (options?.reportParams) {
        void queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.PAYMENT_RUN_REVIEW(options.reportParams),
        });
      }
    },
  });
};
